import React from 'react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
const tools = [{
  icon: '📝',
  title: 'Clinical Protocols',
  body: 'Structured protocols to help you organize different stages of evaluation and planning.'
}, {
  icon: '📋',
  title: 'Professional Checklists',
  body: 'Practical checklists designed to help bring consistency to your workflow.'
}, {
  icon: '🧠',
  title: 'Decision Trees',
  body: 'Visual frameworks that move you from a clinical question to the next point of evaluation.'
}, {
  icon: '📊',
  title: 'Assessment Matrices',
  body: 'Organize variables, priorities and risk factors in one place.'
}, {
  icon: '🗂️',
  title: 'Case Planning Worksheets',
  body: 'Document observations, hypotheses and decisions throughout the planning process.'
}, {
  icon: '⚡',
  title: 'Quick Reference Guides',
  body: 'Condensed tools for fast consultation when you don’t want to search through pages of theory.'
}];
export function ClinicalTools() {
  return <Section tone="dark" data-id="element-112" data-mp="m8smz6nrf1eh">
      <SectionHeading eyebrow="Included with your access" title="Plus 30+ practical clinical tools" data-id="element-113" data-mp="m7hlxelp87r2" />

      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-114" data-mp="zyw5bmjiqayn">
        {tools.map(tool => <article key={tool.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-950 p-5" data-id="element-115" data-mp="vznccjwayh45">
            <span className="text-2xl" aria-hidden="true" data-id="element-116" data-mp="39y8zzw4e4zd">
              {tool.icon}
            </span>
            <h3 className="mt-3 text-[15px] font-bold uppercase tracking-wide text-gold-400" data-id="element-117" data-mp="h97r553vz95z">
              {tool.title}
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-300" data-id="element-118" data-mp="c9ldiuk5bqwn">{tool.body}</p>
          </article>)}
      </div>

      <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold-500/30 bg-navy-950 p-6 text-center" data-id="element-119" data-mp="1sqpkdanucqe9">
        <h3 className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-120" data-mp="lc414rphhqwq">
          This isn’t about memorizing more. It’s about having a process to follow.
        </h3>
        <div className="mt-5 space-y-3 text-[15px] leading-relaxed" data-id="element-121" data-mp="qd1hcyqxoavl">
          <p className="text-slate-400" data-id="element-122" data-mp="udbmk96wix9e">
            Instead of asking: <span className="italic" data-id="element-123" data-mp="zceqtrf24zgb">“What am I supposed to remember?”</span>
          </p>
          <p className="font-semibold text-gold-400" data-id="element-124" data-mp="2lw32o0n5qne">
            You can ask: “What does my clinical workflow tell me to evaluate next?”
          </p>
        </div>
      </div>

      <div className="mt-8 flex justify-center" data-id="element-125" data-mp="6kv2xu7imx7z">
        <CtaButton label="I want the Playbook" subLabel="One-time payment of $27" data-id="element-126" data-mp="bl9bregxyb72" />
      </div>
    </Section>;
}